<template>
    <div class="container">
        <p>模板名</p>
        <el-input v-model="template_name"></el-input>
        <p style="margin-top:30px">表单列表</p>
        <div style="margin-top:20px"><el-button type="primary" size="small" @click="addDimension">添加表单</el-button></div>
        <el-table :data="dimensions_list" v-loading="loading" style="margin-top:20px">
            <el-table-column label="字段(英文)" prop="key"></el-table-column>
            <el-table-column label="字段名" prop="label"></el-table-column>
            <el-table-column label="介绍" prop="instruction"></el-table-column>
            <el-table-column label="表单类型" prop="form_type"></el-table-column>
            <el-table-column label="表单值" prop="form_value"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="edit(scope.row)" size="small">修改</el-button>
                    <el-button type="primary" @click="remove(scope.$index)" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top:20px">
            <el-button type="primary" @click="updateWorkshopTemplate">提交</el-button>
        </div>
        <el-dialog title="编辑表单" :visible.sync="showMension">
            <p>字段名(英文)</p>
            <el-input v-model="key"></el-input>
            <p>字段名</p>
            <el-input v-model="label"></el-input>
            <p>介绍</p>
            <el-input v-model="instruction"></el-input>
            <p>表单类型</p>
            <el-select v-model="form_type">
                <el-option v-for="(item,index) in forms" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div v-if="form_type==='select'" style="margin-top:20px">
                <el-button size="mini" @click="addSelect" type="primary">添加选项</el-button>
                <p>选项模板</p>
                <el-select v-model="selectTemplate">
                    <el-option v-for="(item,index) in selectValue" :key="index" :value="item" :label="item"></el-option>
                </el-select>
            </div>
            <div style="margin-top:20px"><el-button type="primary" size="small" @click="confirmAdd">确定</el-button></div>
        </el-dialog>
        <el-dialog title="编辑选项" :visible.sync="showSelect">
            <p>选项名</p>
            <el-input type="text" v-model="newSelect"></el-input>
            <div style="margin-top:20px">
                <el-button type="primary" size="small" @click="confirmAddSelect">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {updateWorkshopTemplate,getWorkshopTemplate} from '../../api/assistant'
export default {
    data(){
        return{
            id:'',
            template_name:'',
            activeNames:[],
            dimensions_list:[],
            key:'',
            label:'',
            instruction:'',
            form_type:'',
            showMension:false,
            showSelect:false,
            loading:false,
            forms:[
                {value:'input',label:'文字输入框'},
                {value:'textarea',label:'多行文字输入框'},
                {value:'select',label:'选择框'},
                {value:'file',label:'文件上传框'}
            ],
            selectValue:[],
            selectTemplate:'',
            newSelect:''
        }
    },
    mounted(){
        this.id = this.$route.query.id
        if(this.id){
            this.fetchData()
        }
    },
    methods:{
        fetchData(){
            this.loading=true
            getWorkshopTemplate(this.id).then(res=>{
                if(res.data.code===0){
                    this.template_name = res.data.data.name
                    let dimensions = res.data.data.dimensions
                    for(let i in dimensions){
                        this.dimensions_list.push({
                            key:i,
                            label:dimensions[i].label,
                            instruction:dimensions[i].instruction,
                            form_type:dimensions[i].form_type,
                            form_value:dimensions[i].form_value?dimensions[i].form_value:''
                        });
                    }
                    this.loading=false
                }
            })
        },
        addDimension(){
            this.key=''
            this.label=''
            this.instruction=''
            this.form_type=''
            this.selectValue = []
            this.showMension = true
        },
        confirmAdd(){
            let model = {
                key:this.key,
                label:this.label,
                instruction:this.instruction,
                form_type:this.form_type,
                form_value:this.form_type==='select'?this.selectValue:[]
            }
            this.dimensions_list.push(model)
            this.showMension = false
        },
        updateWorkshopTemplate(){
            let dimensions = {}
            this.dimensions_list.map(item=>{
                dimensions[item.key] = {
                    label:item.label,
                    instruction:item.instruction,
                    form_type:item.form_type,
                    form_value:item.form_value?item.form_value:[]
                };
            })
            updateWorkshopTemplate(this.id,this.template_name,dimensions).then(res=>{
                if(res.data.code===0){
                    this.$message({
                        message:'更新成功',
                        type:'success'
                    })
                    this.$router.back(-1)
                }
            })
        },
        remove(index){
            this.dimensions_list.splice(index,1);
        },
        addSelect(){
            this.newSelect = ''
            this.showSelect = true
        },
        confirmAddSelect(){
            this.selectValue.push(this.newSelect)
            this.showSelect = false
        },
        edit(row){
            this.key= row.key
            this.label = row.label
            this.instruction=row.instruction
            this.form_type=row.form_type
            this.selectValue = row.form_value
            this.showMension = true
        }
    }
}
</script>

<style>

</style>